import Swiper from 'swiper';
import 'swiper/css';

export const initBlogsSlider = (slider) => {
    const swiper = new Swiper(slider, {
        slidesPerView: 1.5,
        spaceBetween: 16,
        navigation: {
            nextEl: ".js-blogs-slider-next",
            prevEl: ".js-blogs-slider-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 3.5,
            },
        },
    });
};

[...document.querySelectorAll('.js-blogs-slider')].map(initBlogsSlider);
